<!-- 由 suu 创建于 2022-01-24 星期一 -->
<template>
  <div class="ques-item">
    <div class="i-title">
      {{ info.field_title
      }}<span v-if="type[info.field_type]">{{ type[info.field_type] }}</span>
    </div>
    <!-- 目前选项就一种形式 -->
    <!-- type = radio  -->
    <div class="i-option-region">
      <div
        @click="handelOpClick(index)"
        class="i-option"
        :class="{ 'i-option-ac': active.includes(index) }"
        v-for="(item, index) in info.field_unit"
        :key="index"
      >
        {{ item.key }}：{{ item.value }}
      </div>
    </div>
    <div
      v-if="!showTips"
      class="i-btn user-btn"
      @click="handelConfim"
      :class="{ 'i-btn-on': active.length }"
    >
      确定
    </div>
    <template v-if="showTips">
      <!-- 正确答案 解析 -->
      <div class="i-answer">
        正确答案：{{
          info.value.length > 1 ? info.value.join('、') : info.value
        }}
      </div>
      <div class="i-tips" v-if="info.tips">
        <div>答案解析：</div>
        <div class="t-cent">{{ info.tips }}</div>
      </div>
      <!-- 下一题 -->
      <div class="i-next user-btn" @click="handelNext">
        {{ final ? '提交' : '下一题' }} <van-icon name="play" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ques-item',

  components: {},

  props: {
    info: {},
    final: {}
  },

  data() {
    return {
      type: {
        radio: '(单选)',
        checkbox: '(多选)'
      },
      active: [],
      showTips: false
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 下一题
     */
    handelNext() {
      this.$emit('next', this.active)
    },
    /**
     * 选项确定
     */
    handelConfim() {
      if (!this.active.length) return
      this.showTips = true
    },
    /**
     * 点击选项
     */
    handelOpClick(i) {
      if (this.info.field_type == 'checkbox') {
        // 多选
        const cur = this.active.findIndex((v) => {
          return v == i
        })
        if (cur > -1) {
          this.active.splice(cur, 1)
        } else {
          this.active.push(i)
        }
      } else if (this.info.field_type == 'radio') {
        // 单选
        this.$set(this.active, 0, i)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.ques-item {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 3.8vw;
  margin-top: 35px;
  .i-title {
    width: 100%;
    box-sizing: border-box;
    font-size: 18px;
    font-weight: 600;
    box-sizing: border-box;
    span {
      font-size: 12px;
      color: #878787;
      margin-top: -3px;
      display: inline-block;
    }
  }
  .i-option-region {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 20px;
    word-break: break-all;
    .i-option {
      width: 40vw;
      height: 52px;
      box-sizing: border-box;
      background-color: #f1f1f1;
      border-radius: 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      margin-bottom: 16px;
      padding: 0 16px;
      text-align: center;
    }
    .i-option-ac {
      background-image: linear-gradient(90deg, #5f8af6 0%, #3461e5 100%);
      color: #fff;
      font-weight: 600;
    }
  }
  .i-btn {
    font-size: 18px;
    color: #666;
    margin-top: 50px;
    letter-spacing: 2px;
  }
  .i-btn-on {
    color: #000;
  }
  .i-answer {
    font-size: 15px;
    margin-top: 20px;
    font-weight: 600;
  }
  .i-tips {
    width: 100%;
    box-sizing: border-box;
    border-top: 1px solid #f1f1f1;
    font-size: 13px;
    line-height: 22px;
    margin-top: 15px;
    padding-top: 15px;
    .t-cent {
      text-indent: 2em;
    }
  }
  .i-next {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      color: #4b77ee;
      margin-left: 5px;
    }
  }
}
</style>
